import API from './API';

export default {

    findUnits() {
        return API.get("/units")
    }

}
